"use client";

import { useRef } from "react";
import Link from "next/link";
import AppImage from "@/components/ui/AppImage";
import Icon from "@/components/ui/AppIcon";

const FeaturedProjectsSection = () => {
  const scrollRef = useRef<HTMLDivElement>(null);

  const projects = [
  {
    id: "project_sonarbangla",
    title: "Sonarbangla",
    location: "Joka, Kolkata – 700104",
    type: "Land for Sale",
    image: "/assets/images/444701890O-1767622133417-1769965986174.jpg",
    alt: "Open land plot in Sonarbangla area with green surroundings",
    badge: "Available Now",
    link: "/projects#sonarbangla"
  },
  {
    id: "project_jokametro",
    title: "Near Joka Metro",
    location: "Joka, Kolkata",
    type: "Land for Sale",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1899fa985-1770029786180.png",
    alt: "Land plot near Joka Metro station with road access",
    badge: "Prime Location",
    link: "/projects#jokametro"
  }];


  const scroll = (direction: "left" | "right") => {
    if (scrollRef.current) {
      const scrollAmount = 400;
      scrollRef.current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth"
      });
    }
  };

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="flex items-end justify-between mb-12">
          <div>
            <p className="text-xs font-bold uppercase tracking-widest text-primary mb-4">
              Our Properties
            </p>
            <h2 className="font-serif text-4xl md:text-6xl font-bold text-foreground tracking-tight">
              Featured <span className="text-primary">Properties</span>
            </h2>
          </div>
          <div className="hidden md:flex gap-3">
            <button
              onClick={() => scroll("left")}
              className="w-12 h-12 rounded-full border border-border flex items-center justify-center text-foreground hover:bg-primary hover:text-white hover:border-primary transition-all"
              aria-label="Scroll left">

              <Icon name="ChevronLeftIcon" size={24} />
            </button>
            <button
              onClick={() => scroll("right")}
              className="w-12 h-12 rounded-full border border-border flex items-center justify-center text-foreground hover:bg-primary hover:text-white hover:border-primary transition-all"
              aria-label="Scroll right">

              <Icon name="ChevronRightIcon" size={24} />
            </button>
          </div>
        </div>

        <div
          ref={scrollRef}
          className="flex gap-6 overflow-x-auto custom-scrollbar pb-6 snap-x snap-mandatory">

          {projects.map((project) =>
          <Link
            key={project.id}
            href={project.link}
            className="group shrink-0 w-[85vw] md:w-[45vw] lg:w-[35vw] snap-start">

              <div className="relative aspect-[4/3] rounded-2xl overflow-hidden bg-muted">
                <AppImage
                src={project.image}
                alt={project.alt}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />

                <div className="absolute inset-0 bg-gradient-to-t from-foreground/80 to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-6">
                  <div className="flex items-center justify-between mb-3">
                    <span className="px-4 py-2 bg-secondary/90 backdrop-blur-sm text-secondary-foreground rounded-full text-xs font-bold uppercase tracking-wider">
                      {project.badge}
                    </span>
                  </div>
                  <h3 className="font-serif text-3xl font-bold text-white mb-2">
                    {project.title}
                  </h3>
                  <p className="text-white/80 text-sm mb-1 flex items-center gap-2">
                    <Icon name="MapPinIcon" size={16} />
                    {project.location}
                  </p>
                  <p className="text-white/60 text-xs uppercase tracking-wider">
                    {project.type}
                  </p>
                </div>
              </div>
            </Link>
          )}
        </div>

        <div className="text-center mt-12">
          <Link
            href="/projects"
            className="inline-flex items-center gap-2 px-8 py-4 bg-primary text-primary-foreground rounded-lg font-bold hover:bg-accent transition-all hover:scale-105">

            View All Properties
            <Icon name="ArrowRightIcon" size={20} />
          </Link>
        </div>
      </div>
    </section>);

};

export default FeaturedProjectsSection;